module.exports = __webpack_public_path__ + "img/tsp.3533676f.svg";